import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { CssBaseline } from "@mui/material";
import RoutesApp from "./RoutesApp";
import { AccessibilityProvider } from "./Store/contexts/AccessibilityContext";
import { NotificationProvider } from "./Store/contexts/NotificationContext";
import { ThemeModeProvider } from "./Store/contexts/ThemeModeContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

if (process.env.REACT_APP_ENV === "production") {
  const script1 = document.createElement("script");
  script1.src = "https://www.googletagmanager.com/gtag/js?id=G-7JXZ6VVQYE";
  script1.async = true;
  document.head.appendChild(script1);

  const script2 = document.createElement("script");
  script2.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());

    gtag('config', 'G-7JXZ6VVQYE');
  `;
  document.head.appendChild(script2);
}

const App = ({ children }: { children: React.ReactNode }) => (
  <ThemeModeProvider>
    <NotificationProvider>{children}</NotificationProvider>
  </ThemeModeProvider>
);

root.render(
  <AccessibilityProvider>
    <App>
      <CssBaseline />
      <RoutesApp />
    </App>
  </AccessibilityProvider>
);
